import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
import { ApolloProvider } from "@apollo/client";
import client from "./config/apolloClient";
import { AuthProvider } from "./context/auth/auth.context";
import DonorProvider from "./context/donor/donor.context";
import { FilterProvider } from "./context/filter/FilterContext";
import "./locale/i18n";
import { LanguageProvider } from "./context/language/LanguageContext";

// Expose React globally for libraries like react-apexcharts that need it
window.React = React;
window.ReactDOM = ReactDOM;

ReactDOM.render(

  <ApolloProvider client={client}>
    <LanguageProvider>
      <AuthProvider>
        <DonorProvider>
          <FilterProvider>
            <SimpleReactLightbox>
              <App />
            </SimpleReactLightbox>
          </FilterProvider>
        </DonorProvider>
      </AuthProvider>
    </LanguageProvider>
  </ApolloProvider>,
  document.getElementById("root")
);
reportWebVitals();
